module.exports = __webpack_public_path__ + "img/factoryAssembly.e953dbbf.svg";